export default __webpack_public_path__ + "static/media/Banc.133d71cb.png";